// La ilustración de "Separar en capas" en el panel del visor
// (ADR-2026-10-07-separar-en-capas-en-el-visor): unas capas apiladas que se abren en 3D y
// se vuelven a juntar, en loop, para que se entienda qué hace la herramienta sin leer.
//
// `CAPAS_DE_EJEMPLO` son los PNG de una imagen ya separada, de atrás hacia adelante (el
// primero, el fondo entero). Mientras esté vacío se dibujan capas genéricas.

import type { CSSProperties } from 'react';

/** PNG en `public/images/capas-ejemplo/`, de atrás hacia adelante. */
export const CAPAS_DE_EJEMPLO: readonly string[] = [];

/** Cuánto se separa cada capa de la siguiente cuando se abren, en px. */
const PASO_Z = 26;

const GENERICAS: { clase: string; estilo: CSSProperties }[] = [
  // El fondo: la foto entera.
  { clase: 'inset-0 rounded-[10px] bg-[linear-gradient(160deg,#3b4a6b_0%,#1d2540_60%,#141a2e_100%)]', estilo: {} },
  // Un elemento: el producto.
  { clase: 'rounded-[12px] bg-[linear-gradient(170deg,#e9edf7,#b9c4dc)] shadow-lg', estilo: { left: '30%', top: '26%', width: '40%', height: '52%' } },
  // Un texto.
  { clase: 'rounded-full bg-white/90', estilo: { left: '18%', top: '10%', width: '64%', height: '8%' } },
];

export function IlustracionDeCapas() {
  const capas = CAPAS_DE_EJEMPLO.length > 0 ? CAPAS_DE_EJEMPLO : null;
  const n = capas ? capas.length : GENERICAS.length;
  return (
    <div aria-hidden="true" className="relative grid h-[168px] place-items-center overflow-hidden rounded-[13px] border border-white/[0.07] bg-white/[0.04]" style={{ perspective: 900 }}>
      <div className="capas-ejemplo-plano relative h-[118px] w-[94px]" style={{ transformStyle: 'preserve-3d' }}>
        {Array.from({ length: n }).map((_, i) => {
          const z = { ['--z' as string]: `${(i - (n - 1) / 2) * PASO_Z}px` } as CSSProperties;
          return capas ? (
            <img
              key={capas[i]}
              src={capas[i]}
              alt=""
              className="capas-ejemplo-capa absolute inset-0 h-full w-full object-contain"
              style={z}
            />
          ) : (
            <span
              key={i}
              className={`capas-ejemplo-capa absolute outline outline-1 outline-white/25 ${GENERICAS[i].clase}`}
              style={{ ...GENERICAS[i].estilo, ...z }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default IlustracionDeCapas;
